import React, { Fragment, useState,useContext } from 'react'
import {AppTableColumnProps} from './AppTableColumn'
import {Checkbox,Icon} from 'antd'
import {AppTableContext} from "./AppTableProvider"
import {appDate,appNumber} from 'utils'

interface RowProps {
    columns?: AppTableColumnProps[];
    data?: any;
	dataIndex?: number;
}

interface ColProps extends AppTableColumnProps {
	data?: any;
	dataIndex?: number;
}

export const AppTableRow = (props:RowProps) =>{
    let { columns,data,dataIndex } = props; 
    let {handleRowHover,hovered,handleRowClick,actived,keyName} = useContext(AppTableContext);

    let isHover = data[keyName] === hovered[keyName];

    const rowHover = () =>{
		if(data[keyName]===hovered[keyName]) return;
		handleRowHover(data);
    }
    
    const rowClick = () =>{
		if(data[keyName]===actived[keyName]) return;
		handleRowClick(data);
	}

    return (
        <tr key={`${data[keyName]}_app_table_row`}
            className={data[keyName] ===actived[keyName] ? 'app-table-data-actived':'app-table-data-row'}
            data-hover = {isHover}
            hidden = {data._table_hidden}
            onMouseOver={() => { rowHover() }}
            onClick={() => { rowClick() }}
            >
            {columns.map((column: AppTableColumnProps,index) => {
                return <AppTableColumnItem key ={index} {...column} data={data} dataIndex={dataIndex} />;
            })}
        </tr>)
}




export const AppTableColumnItem = (props:ColProps) =>{
    const { handleCheck ,handleExpand} = useContext(AppTableContext)
    const {data,dataIndex,field,format,dataType} = props

    const checkbox = () =>{
        return <div> 
            <Checkbox 
                checked={data._table_checked} 
                indeterminate = {data._table_indeterminate}
                onChange={(e)=>{handleCheck(data,e.target.checked)}} 
            />
        </div>
    }

    const itemContent = () =>{
        if(props.field === "_table_check_box") {
            return checkbox()
        } else if(props.render) {
            return props.render(data,dataIndex);
        }else{
            return appFormat(dataType,data[field], format);
        }
    }
    

    const expandItem = () =>{
        let {_tree_end,_tree_level,_table_expand_icon} = data
        let blankWidth:number = _tree_end? _tree_level : (_tree_level-1);
        blankWidth = blankWidth * 15 +5;
        return (
        <div className="app-table-expand-column-container">
            <div className="app-table-expand-blank" style={{width:blankWidth}}></div>
            <div className="app-table-expand-data">
                {_tree_end? <React.Fragment/> : 
                                    <span className='app-table-tree-icon' 
                                           onClick={()=>{handleExpand(data)}}>
                                        <Icon type={_table_expand_icon} />
                                    </span>}
                {itemContent()}
            </div>
        </div>
        )
    }

    return (
        <td style={{textAlign:props.align || 'left'}}>
             <div className="app-table-data-td-outer">
                <div className="app-table-data-td-inner" style={{textAlign:props.align || 'left'}}>
                    {props.expand?expandItem():itemContent()}
                </div>
            </div>
        </td>
    );
}

const appFormat = (dataType?:string,value?:string | number,fmt?:string) =>{
    if(value !== null && value !== undefined && value === 0) value = '0'
    let stringValue = `${value||''}`;
    if(dataType === 'number') return appNumber.format(stringValue,fmt);
    if(dataType === 'date' || dataType === 'datetime' ) return appDate.format(stringValue,fmt);
    return stringValue; 
}







// WEBPACK FOOTER //
// ./src/qcc/AppTable/AppTableRow.tsx